import { useState } from 'react';
import { collection, query, where, getDocs } from 'firebase/firestore';
import { db } from '../../lib/firebase';

export default function useValidateOrderQuantity() {
  const [errors, setErrors] = useState({});

  const validateQuantity = async (sku, desiredQuantity) => {
    try {
      const productsRef = collection(db, 'products');
      const q = query(productsRef, where('sku', '==', sku));
      const snapshot = await getDocs(q);

      if (snapshot.empty) {
        throw new Error('Product not found');
      }

      const product = snapshot.docs[0].data();

      if (desiredQuantity > product.quantity) {
        setErrors(prev => ({ ...prev, [sku]: `Only ${product.quantity} in stock.` }));
        return false;
      }

      setErrors(prev => ({ ...prev, [sku]: null }));
      return true;
    } catch (err) {
      setErrors(prev => ({ ...prev, [sku]: err.message }));
      return false;
    }
  };

  return { validateQuantity, errors };
}
